export const ar = {
    nav: {
        dashboard: 'لوحة التحكم',
        board: 'لوحة',
        list: 'قائمة',
        settings: 'الإعدادات',
        reports: 'التقارير',
        myTasks: 'مهامي',
        activity: 'النشاط',
        charts: 'الرسوم البيانية',
        team: 'الفريق',
        timeTracking: 'تتبع الوقت',
        admin: 'الإدارة',
        adminOverview: 'نظرة عامة على الإدارة',
        userManagement: 'إدارة المستخدمين',
        projectSetup: 'إعداد المشروع',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'إدارة المشاريع بالـ Markdown',
        version: 'الإصدار',
        back: 'رجوع',
        loading: 'جاري التحميل...',
        noData: 'لا توجد بيانات',
        search: 'بحث',
        filter: 'تصفية',
        all: 'الكل',
        close: 'إغلاق',
        open: 'فتح',
        connect: 'اتصال',
        archived: 'مؤرشف',
        inactive: 'غير نشط',
        active: 'نشط',
        untitled: 'بدون عنوان',
        unknown: 'غير معروف',
        tasks: 'المهام',
        done: 'مكتمل',
        lastModified: 'آخر تعديل',
        created: 'تم الإنشاء',
        points: 'نقاط',
        pts: 'نقاط',
        yes: 'نعم',
        no: 'لا',
        or: 'أو',
    },
    actions: {
        create: 'إنشاء',
        edit: 'تعديل',
        delete: 'حذف',
        save: 'حفظ',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        add: 'إضافة',
        remove: 'إزالة',
        update: 'تحديث',
        close: 'إغلاق',
        submit: 'إرسال',
        reset: 'إعادة تعيين',
        load: 'تحميل',
        export: 'تصدير',
        import: 'استيراد',
        archive: 'أرشفة',
        restore: 'استعادة',
        deactivate: 'تعطيل',
        activate: 'تفعيل',
    },
    auth: {
        signIn: 'تسجيل الدخول',
        signOut: 'تسجيل الخروج',
        signUp: 'إنشاء حساب',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
        displayName: 'الاسم المعروض',
        email: 'البريد الإلكتروني',
        role: 'الدور',
        createAccount: 'إنشاء حساب',
        dontHaveAccount: 'ليس لديك حساب؟',
        alreadyHaveAccount: 'لديك حساب بالفعل؟',
        signInToAccount: 'سجّل الدخول إلى حسابك',
        createYourAccount: 'أنشئ حسابك',
        enterUsername: 'أدخل اسم المستخدم',
        enterPassword: 'أدخل كلمة المرور',
        chooseUsername: 'اختر اسم مستخدم',
        yourFullName: 'اسمك الكامل',
        atLeast6Chars: '6 أحرف على الأقل',
        confirmPasswordPlaceholder: 'أكّد كلمة المرور',
        pleaseEnterCredentials: 'يرجى إدخال اسم المستخدم وكلمة المرور',
        invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
        pleaseFillAllFields: 'يرجى ملء جميع الحقول',
        passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين',
        passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
        usernameExists: 'اسم المستخدم موجود بالفعل',
        demoCredentials: 'بيانات الدخول التجريبية',
        admin: 'مدير',
        manager: 'مدير مشاريع',
        developer: 'مطور',
        viewer: 'مشاهد',
        contactAdminForRole: 'تواصل مع المسؤول لتغيير الدور',
        usernameCannotBeChanged: 'لا يمكن تغيير اسم المستخدم',
    },
    statuses: {
        backlog: 'قائمة المهام',
        todo: 'للقيام به',
        inProgress: 'قيد التنفيذ',
        inReview: 'قيد المراجعة',
        done: 'مكتمل',
        planned: 'مخطط',
        inProgressSprint: 'قيد التنفيذ (سبرينت)',
        completed: 'مكتمل',
        allStatus: 'جميع الحالات',
    },
    priorities: {
        critical: 'حرج',
        high: 'عالي',
        medium: 'متوسط',
        low: 'منخفض',
    },
    messages: {
        noProjects: 'لا توجد مشاريع بعد',
        noTasks: 'لا توجد مهام',
        confirmDelete: 'هل أنت متأكد أنك تريد حذف هذا؟',
        saved: 'تم الحفظ بنجاح',
        error: 'حدث خطأ',
        noTasksAssigned: 'لا توجد مهام مسندة إليك',
        noActivityYet: 'لا يوجد نشاط بعد',
        confirmReset: 'سيؤدي هذا إلى إعادة تعيين جميع البيانات إلى الحالة الأولية. هل تريد المتابعة؟',
        removeUserConfirm: 'هل أنت متأكد أنك تريد إزالة هذا المستخدم؟',
        deleteProjectConfirm: 'هل أنت متأكد أنك تريد حذف هذا المشروع؟',
        archiveProjectConfirm: 'هل أنت متأكد أنك تريد أرشفة هذا المشروع؟',
    },
    settings: {
        title: 'الإعدادات',
        theme: 'المظهر',
        language: 'اللغة',
        languageAndRegion: 'اللغة والمنطقة',
        gitConfig: 'إعدادات Git',
        gitIntegration: 'تكامل Git',
        gitProvider: 'مزود Git',
        repositoryUrl: 'رابط المستودع',
        seedData: 'بيانات تجريبية',
        seedDataDescription: 'تحميل مشاريع نموذجية مع مهام وسبرينتات وقصص lớn للاختبار. سيؤدي هذا إلى إعادة تعيين جميع البيانات إلى الحالة الأولية.',
        loadSeedData: 'تحميل البيانات التجريبية',
        seedDataConfirm: 'سيؤدي هذا إلى إعادة تعيين جميع البيانات إلى الحالة الأولية. هل تريد المتابعة؟',
        appearance: 'المظهر',
        notifications: 'الإشعارات',
    },
    themes: {
        summer: 'الصيف',
        spring: 'الربيع',
        autumn: 'الخريف',
        winter: 'الشتاء',
        day: 'النهار',
        night: 'الليل',
        summerDay: 'صيف نهاري',
        summerNight: 'صيف ليلي',
        springDay: 'ربيع نهاري',
        springNight: 'ربيع ليلي',
        autumnDay: 'خريف نهاري',
        autumnNight: 'خريف ليلي',
        winterDay: 'شتاء نهاري',
        winterNight: 'شتاء ليلي',
        highContrast: 'تباين عالي',
        selectTheme: 'اختر المظهر',
    },
    time: {
        hours: 'ساعات',
        minutes: 'دقائق',
        days: 'أيام',
        weeks: 'أسابيع',
        justNow: 'الآن',
        minutesAgo: 'منذ {{count}} د',
        hoursAgo: 'منذ {{count}} س',
        daysAgo: 'منذ {{count}} ي',
        updatedAt: 'تم التحديث',
    },
    reports: {
        velocity: 'السرعة',
        burndown: 'مخطط الاحتراق',
        burnup: 'مخطط الارتفاع',
        cycleTime: 'وقت الدورة',
        leadTime: 'وقت التسليم',
        throughput: 'الإنتاجية',
        gantt: 'مخطط جانت',
        cumulativeFlow: 'التدفق التراكمي',
    },
    globalSearch: {
        placeholder: 'البحث عن مشاريع، مهام، سبرينتات...',
        noResults: 'لم يتم العثور على نتائج',
        projects: 'المشاريع',
        tasks: 'المهام',
        sprints: 'السبرينتات',
        epics: 'القصص الكبرى',
    },
    notifications: {
        title: 'الإشعارات',
        markAllRead: 'تحديد الكل كمقروء',
        clearAll: 'مسح الكل',
        empty: 'لا توجد إشعارات',
        unread: '{count} غير مقروء',
    },
    dashboard: {
        totalProjects: 'إجمالي المشاريع',
        totalTasks: 'إجمالي المهام',
        completion: 'الإكمال',
        statusBreakdown: 'تفصيل الحالات',
        createProject: 'إنشاء مشروع',
        loadSeedData: 'تحميل بيانات تجريبية',
        noProjects: 'لا توجد مشاريع بعد',
        getStarted: 'ابدأ بإنشاء مشروع جديد أو تحميل بيانات تجريبية.',
        projects: 'المشاريع',
        newProject: 'مشروع جديد',
        createNewProject: 'إنشاء مشروع جديد',
        projectName: 'اسم المشروع',
        description: 'الوصف',
        workflow: 'سير العمل',
        skipToMain: 'انتقل إلى المحتوى الرئيسي',
        projectProgress: 'تقدم المشروع',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'الجلالي',
        hijri: 'الهجري',
        gregorian: 'الميلادي',
    },
    accessibility: {
        skipToMain: 'انتقل إلى المحتوى الرئيسي',
        board: 'لوحة المهام',
        projectList: 'قائمة المشاريع',
        mainNav: 'التنقل الرئيسي',
        selectTheme: 'اختر المظهر',
        projectDashboard: 'لوحة تحكم المشروع',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'اللوحة',
        kanban: 'كانبان',
        scrum: 'سكرم',
    },
    task: {
        title: 'المهمة',
        createTask: 'إنشاء مهمة',
        editTask: 'تعديل المهمة',
        deleteTask: 'حذف المهمة',
        assignee: 'المسؤول',
        unassigned: 'غير مسند',
        storyPoints: 'نقاط القصة',
        labels: 'التصنيفات',
        description: 'الوصف',
        acceptanceCriteria: 'معايير القبول',
        timeLog: 'سجل الوقت',
        comments: 'التعليقات',
        addComment: 'إضافة تعليق',
        noComments: 'لا توجد تعليقات بعد',
        status: 'الحالة',
        priority: 'الأولوية',
        created: 'تم الإنشاء',
        updated: 'تم التحديث',
        started: 'تم البدء',
    },
    sprint: {
        title: 'السبرينت',
        createSprint: 'إنشاء سبرينت',
        sprintGoal: 'هدف السبرينت',
        committedPoints: 'النقاط الملتزم بها',
        completedPoints: 'النقاط المكتملة',
        velocity: 'السرعة',
        planned: 'مخطط',
        inProgress: 'قيد التنفيذ',
        completed: 'مكتمل',
    },
    team: {
        title: 'الفريق',
        members: 'الأعضاء',
        role: 'الدور',
        availability: 'التوفر',
        assignedTasks: 'المهام المسندة',
        activeTasks: 'المهام النشطة',
        doneTasks: 'المهام المكتملة',
    },
    timeTracking: {
        title: 'تتبع الوقت',
        timer: 'المؤقت',
        manualEntry: 'إدخال يدوي',
        startTime: 'وقت البداية',
        stopTime: 'وقت النهاية',
        duration: 'المدة',
        date: 'التاريخ',
        totalHours: 'إجمالي الساعات',
        entries: 'السجلات',
        noEntries: 'لا توجد سجلات بعد',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'لوحة تحكم الإدارة',
        projects: 'المشاريع',
        totalTasks: 'إجمالي المهام',
        storyPoints: 'نقاط القصة',
        taskStatusBreakdown: 'تفصيل حالات المهام',
        projectProgress: 'تقدم المشروع',
        teamWorkload: 'حمل عمل الفريق',
        assigned: 'مسند',
        active: 'نشط',
    },
    myTasks: {
        title: 'مهامي',
        total: 'الإجمالي',
        inProgress: 'قيد التنفيذ',
        inReview: 'قيد المراجعة',
        done: 'مكتمل',
        completion: 'الإكمال',
        allStatus: 'جميع الحالات',
        allProjects: 'جميع المشاريع',
        noTasksAssigned: 'لا توجد مهام مسندة إليك',
    },
    activity: {
        title: 'تغذية النشاط',
        commentsOnYourTasks: 'تعليقات على مهامك',
        allActivity: 'جميع الأنشطة',
        noActivityYet: 'لا يوجد نشاط بعد',
        commentedOn: 'علّق على',
        movedTo: 'نقل إلى',
    },
    profile: {
        title: 'الملف الشخصي',
        avatar: 'الصورة الرمزية',
        dragDropImage: 'اسحب وأفلت صورة هنا، أو تصفح الملفات',
        browse: 'تصفح',
        imageFormats: 'PNG، JPG، WEBP حتى 2 ميغابايت',
        removePhoto: 'إزالة الصورة',
        saveChanges: 'حفظ التغييرات',
        profileSaved: 'تم حفظ الملف الشخصي',
        contactAdmin: 'تواصل مع المسؤول لتغيير الدور',
    },
};
//# sourceMappingURL=ar.js.map